import { FormFieldTypes } from "../../../../../data/formFieldType";

export const AddSGBPCategoryData = {
  name: "AdditionalInfo",
  initialState: {
    channel: null,
    category: null,
    subCategory: null,
    type: null,
    code: null,
    certificateTemplate: null,
  },
  formFields: [
    {
      id: "channel",
      lable: "Channel",
      Field_Name: "Channel",
      fieldType: FormFieldTypes.SELECT,
      dataField: "channel",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },
    {
      id: "category",
      lable: "Category (L1)",
      Field_Name: "Category (L1)",
      fieldType: FormFieldTypes.SELECT,
      dataField: "category",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isSearchable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "subCategory",
      lable: "Sub Category (L2)",
      Field_Name: "Sub Category (L2)",
      fieldType: FormFieldTypes.SELECT,
      dataField: "subCategory",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isSearchable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "type",
      lable: "Type (L3)",
      Field_Name: "Type (L3)",
      fieldType: FormFieldTypes.SELECT,
      dataField: "type",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isSearchable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "code",
      lable: "Code",
      Field_Name: "Code",
      fieldType: FormFieldTypes.SELECT,
      dataField: "code",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isSearchable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },
    {
      id: "certificateTemplate",
      lable: "Certificate Template",
      Field_Name: "Certificate Template",
      fieldType: FormFieldTypes.SELECT,
      dataField: "certificateTemplate",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
